import React, { useMemo } from "react";
import { getRecommendations } from "../utils/cancerRecommendations";
import "../styles/components/AuditPage.css";

const personas = [
  { name: "26F Chinese, healthy", profile: { age: 26, biologicalSex: "female", ethnicity: "asian", familyCancerHistory: ["none"], weightInKg: 55, heightInCm: 163, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "26M Chinese, healthy", profile: { age: 26, biologicalSex: "male", ethnicity: "asian", familyCancerHistory: ["none"], weightInKg: 70, heightInCm: 175, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "26F Chinese, light smoker, occasional drinker", profile: { age: 26, biologicalSex: "female", ethnicity: "asian", familyCancerHistory: ["none"], weightInKg: 58, heightInCm: 160, chronicDiseases: ["none"], smokingHistory: 3, cigarettesPerDay: 5, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "under_7", dietHabits: "no" }},
  { name: "30F White, no risk factors", profile: { age: 30, biologicalSex: "female", ethnicity: "white", familyCancerHistory: ["none"], weightInKg: 60, heightInCm: 165, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "35M White, no risk factors", profile: { age: 35, biologicalSex: "male", ethnicity: "white", familyCancerHistory: ["none"], weightInKg: 80, heightInCm: 178, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "40F Asian, breast cancer FH", profile: { age: 40, biologicalSex: "female", ethnicity: "asian", familyCancerHistory: ["breast"], weightInKg: 55, heightInCm: 160, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "45F White, obese (BMI 34.9), moderate drinker, bad diet", profile: { age: 45, biologicalSex: "female", ethnicity: "white", familyCancerHistory: ["none"], weightInKg: 95, heightInCm: 165, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "14_to_21", dietHabits: "yes" }},
  { name: "50M White, average risk", profile: { age: 50, biologicalSex: "male", ethnicity: "white", familyCancerHistory: ["none"], weightInKg: 82, heightInCm: 180, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "50F Asian, average risk", profile: { age: 50, biologicalSex: "female", ethnicity: "asian", familyCancerHistory: ["none"], weightInKg: 58, heightInCm: 158, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "55M Black, heavy smoker (30 pack-yrs), moderate drinker", profile: { age: 55, biologicalSex: "male", ethnicity: "black", familyCancerHistory: ["none"], weightInKg: 85, heightInCm: 178, chronicDiseases: ["none"], smokingHistory: 30, cigarettesPerDay: 20, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "7_to_14", dietHabits: "no" }},
  { name: "55M Asian, hepatitis B, liver FH, moderate drinker", profile: { age: 55, biologicalSex: "male", ethnicity: "asian", familyCancerHistory: ["liver"], weightInKg: 72, heightInCm: 170, chronicDiseases: ["hepatitis_b"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "7_to_14", dietHabits: "no" }},
  { name: "60F White, BRCA + breast & ovarian FH", profile: { age: 60, biologicalSex: "female", ethnicity: "white", familyCancerHistory: ["breast", "ovarian"], weightInKg: 65, heightInCm: 165, chronicDiseases: ["BRCA mutation"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "60M White, colon + prostate FH, light drinker, overweight", profile: { age: 60, biologicalSex: "male", ethnicity: "white", familyCancerHistory: ["colon", "prostate"], weightInKg: 90, heightInCm: 180, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "under_7", dietHabits: "no" }},
  { name: "35F Hispanic, HPV positive", profile: { age: 35, biologicalSex: "female", ethnicity: "hispanic", familyCancerHistory: ["none"], weightInKg: 65, heightInCm: 160, chronicDiseases: ["hpv"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "70F Asian, average risk", profile: { age: 70, biologicalSex: "female", ethnicity: "asian", familyCancerHistory: ["none"], weightInKg: 52, heightInCm: 155, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "22M White, zero risk factors", profile: { age: 22, biologicalSex: "male", ethnicity: "white", familyCancerHistory: ["none"], weightInKg: 75, heightInCm: 180, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "none", dietHabits: "no" }},
  { name: "45M Asian, overweight, secondhand smoke, bad diet", profile: { age: 45, biologicalSex: "male", ethnicity: "asian", familyCancerHistory: ["none"], weightInKg: 85, heightInCm: 170, chronicDiseases: ["none"], smokingHistory: 0, cigarettesPerDay: 0, livedWithSmoker: "yes", radiationExposure: "no", alcoholConsumption: "under_7", dietHabits: "yes" }},
  { name: "65F Black, obese, diabetes, heavy drinker, smoker, breast FH", profile: { age: 65, biologicalSex: "female", ethnicity: "black", familyCancerHistory: ["breast"], weightInKg: 100, heightInCm: 165, chronicDiseases: ["diabetes"], smokingHistory: 20, cigarettesPerDay: 15, livedWithSmoker: "no", radiationExposure: "no", alcoholConsumption: "21_to_50", dietHabits: "yes" }},
];

function getRiskClass(score) {
  if (score >= 2.5) return "risk-high";
  if (score >= 1.5) return "risk-medium";
  return "risk-low";
}

function RecItem({ rec }) {
  const flagged = rec.riskScore < 1.0;
  return (
    <li className={`audit-rec-item ${flagged ? "flagged" : ""}`}>
      <div>
        <span className="cancer-name">{rec.cancer}</span>
        {rec.guidelineSource && <span className="guideline-source"> — {rec.guidelineSource}</span>}
        <div className="risk-factors">
          {rec.riskFactors?.map((rf, i) => (
            <span key={i}>{rf.factor} ({rf.multiplier.toFixed(1)}x){i < rec.riskFactors.length - 1 ? " · " : ""}</span>
          ))}
        </div>
      </div>
      <span className={`risk-score ${getRiskClass(rec.riskScore)}`}>{rec.riskScore.toFixed(1)}x</span>
    </li>
  );
}

export default function AuditPage() {
  const results = useMemo(() => {
    return personas.map((p) => {
      const recs = getRecommendations(p.profile);
      const all = [...recs.stronglyRecommend, ...recs.recommend];
      const bmi = p.profile.weightInKg / ((p.profile.heightInCm / 100) ** 2);
      const packYears = (p.profile.smokingHistory * p.profile.cigarettesPerDay / 20);
      const primaries = all.filter((r) => r.tier === "primary");
      const secondaries = all.filter((r) => r.tier === "secondary");
      const subThreshold = all.filter((r) => r.riskScore < 1.0);
      return { ...p, recs, all, bmi, packYears, primaries, secondaries, subThreshold };
    });
  }, []);

  const totalRecs = results.reduce((s, r) => s + r.all.length, 0);
  const totalPrimary = results.reduce((s, r) => s + r.primaries.length, 0);
  const totalSecondary = results.reduce((s, r) => s + r.secondaries.length, 0);

  // Collect issues
  const issues = [];
  results.forEach((r) => {
    r.subThreshold.forEach((rec) => {
      issues.push(`${r.name}: "${rec.cancer}" has riskScore ${rec.riskScore.toFixed(1)}x (below 1.0)`);
    });
  });

  // Check skin cancer for white personas
  const whiteSkinCancer = results
    .filter((r) => r.profile.ethnicity === "white")
    .filter((r) => r.all.some((rec) => rec.cancer.toLowerCase().includes("skin")));
  if (whiteSkinCancer.length > 0) {
    issues.push(`Skin cancer showing 3.0x for ALL white personas (${whiteSkinCancer.length} people) — may need nuance`);
  }

  // Check testicular baseline
  const testicularBaseline = results
    .filter((r) => r.profile.biologicalSex === "male")
    .filter((r) => r.all.some((rec) => rec.cancer.toLowerCase().includes("testicular") && rec.riskScore <= 1.0));
  if (testicularBaseline.length > 0) {
    issues.push(`Testicular cancer at 1.0x baseline for ${testicularBaseline.length} male personas — consider if this adds value`);
  }

  return (
    <div className="audit-page">
      <div className="audit-header">
        <h1>🔍 Recommendation Audit</h1>
        <p>{personas.length} personas · {new Date().toLocaleString()} · Dev only</p>
      </div>

      <div className="audit-summary">
        <div className="audit-summary-card">
          <h3>Personas</h3>
          <div className="value">{personas.length}</div>
        </div>
        <div className="audit-summary-card">
          <h3>Total Recs</h3>
          <div className="value">{totalRecs}</div>
        </div>
        <div className="audit-summary-card">
          <h3>Primary</h3>
          <div className="value">{totalPrimary}</div>
        </div>
        <div className="audit-summary-card">
          <h3>Secondary</h3>
          <div className="value">{totalSecondary}</div>
        </div>
        <div className="audit-summary-card">
          <h3>⚠️ Issues</h3>
          <div className="value">{issues.length}</div>
        </div>
      </div>

      {issues.length > 0 && (
        <div className="audit-issues">
          <h3>⚠️ Potential Issues</h3>
          <ul>
            {issues.map((issue, i) => <li key={i}>{issue}</li>)}
          </ul>
        </div>
      )}

      {results.map((r, idx) => (
        <div className="audit-persona" key={idx}>
          <h2>{r.name}</h2>
          <div className="persona-meta">
            Age {r.profile.age} · {r.profile.biologicalSex} · {r.profile.ethnicity} · BMI {r.bmi.toFixed(1)} · Pack-years: {r.packYears.toFixed(1)} · Alcohol: {r.profile.alcoholConsumption} · FH: {r.profile.familyCancerHistory.join(", ")} · Chronic: {r.profile.chronicDiseases.join(", ")}
          </div>
          <span className="rec-count">
            {r.all.length} total — ⚡ {r.recs.stronglyRecommend.length} strongly · {r.recs.recommend.length} regular
          </span>

          {r.primaries.length > 0 && (
            <>
              <div className="audit-section-title">🏥 Primary (National Guidelines)</div>
              <ul className="audit-rec-list">
                {r.primaries.map((rec, i) => <RecItem key={i} rec={rec} />)}
              </ul>
            </>
          )}

          {r.secondaries.length > 0 && (
            <>
              <div className="audit-section-title">🔬 Secondary (Personalized)</div>
              <ul className="audit-rec-list">
                {r.secondaries.map((rec, i) => <RecItem key={i} rec={rec} />)}
              </ul>
            </>
          )}

          {r.all.length === 0 && <p className="audit-no-recs">No recommendations generated.</p>}
        </div>
      ))}
    </div>
  );
}
